/*Orden: [x1, y1, x2, y2]*/
import { ROOM_TYPE } from "@/resources/constants/space";

export const SPACES_VALUES = {
  SMALL: [22.06, -12.67, -26.94, 29.29],
  MEDIUM: [21.56, -11.31, -34.54, 27.68],
  LARGE: [22.8, -15.89, -77.36, 24.93],
  AUTOMOTIVE: [39.28, -14.83, -53.68, 23.41],
  CONFERENCE_CENTER: [33.1, -26.95, -128.9, 24.55],
  TEMPLE: [21.93, -12.4, -26.73, 29.2],
  FESTIVAL: [33.1, -26.95, -128.9, 24.55],
  LEARNING: [22.38, -12.49, -19.78, 24.91],
  MINISO: [23.81, -14.45, -28.73, 31.29],
  CONFERENCE_CENTER_LARGE: [33.1, -67.26, -128.9, 24.55],
  LAKE_SINGLE_WEBINAR: [40.9, -74.61, -73.3, 41.21],
  CONFERENCE_COFFEE: [-49.7, 27.03, 34.3, -24.53],
  CONFERENCE_WEBINAR: [-49.7, 27.03, 34.3, -24.53],
  CONFERENCE_WEBINAR_SPEED_NETWORKING: [-49.7, 27.03, 34.3, -24.53],
  RECREATIVE: [-26.97, 13.15, 21.13, -18.35],
  AUDITORIUM: [-61.3, 50.7, 41.3, -48.5],
  LAKE_SINGLE_WEBINAR_LARGE_WITH_BOOTHS: [-103.7, -41.21, 41.3, 72.7],
  WEBINAR_SPEED_NETWORKING_PLATFORM: [-20.35, -20.17, 20.35, 50.17],
  OFFICE_PLATFORM_NORMAL: [-58.45, -73.98, 45.05, -20.12],
  AUDITORIUM_MINI: [-68.25, 27.03, 35.45, -24.53],
  LEARNING_PLATFORM: [-58.45, 73.98, 45.05, -70.12],
  GAMING_PLATFORM: [-35, -90, 44, -10],
  OFFICE_PLATFORM_NORMAL_TWO: [-94.70, 39.35, 54.30, -46.35],
  HAWKINGS_LARGE: [22.8, -15.89, -77.36, 24.93],
  SHOWROOM_SMALL: [25.30, 9.98, -25.30, -9.98],
  SHOWROOM_VERY_SMALL: [25.30, 9.98, -25.30, -9.98],
  SHOWROOM_NORMAL: [25.30, 9.98, -25.30, -9.98],
  SHOWROOM_LARGE: [25.30, 9.98, -25.30, -9.98],
  SHOWROOM_BIG: [25.30, 9.98, -25.30, -9.98],
  SHOWROOM_SUPER_BIG: [25.30, 9.98, -25.30, -9.98],
  SHOWROOM_NETWORKING: [25.30, 9.98, -25.30, -9.98],
  SHOWROOM_SUPER_OFFICE: [25.30, 9.98, -25.30, -9.98],
  SHOWROOM_INVESTIGATION: [25.30, 9.98, -25.30, -9.98],
  SHOWROOM_SUPER_BIG_WITH_NETWORKING_NO_WALL: [25.30, 9.98, -25.30, -9.98],
  SHOWROOM_FOREST: [25.30, 9.98, -25.30, -9.98],
  SHOWROOM_OASIS: [25.30, 9.98, -25.30, -9.98],
  SHOWROOM_TROPICAL: [25.30, 9.98, -25.30, -9.98],
  SPACE_ISLANDS: [25.30, 9.98, -25.30, -9.98],
  SPACE_ISLANDS_XRF: [25.30, 9.98, -25.30, -9.98],
  SPACE_ENEB: [25.30, 9.98, -25.30, -9.98],
  CTTI_BURRA_CLUB: [25.30, 9.98, -25.30, -9.98],
  ENEB_SPACE_ISLANDS_BLUE: [25.30, 9.98, -25.30, -9.98],
  HESPERIDES_ISLANDS: [25.30, 9.98, -25.30, -9.98],
};
export const SPACES_POSITIONS = {
  HESPERIDES_ISLANDS: {
    "0": { position: { x: 1, y: 3.56, z: -1.5 }, type: ROOM_TYPE.MEETING },
    "1": { position: { x: 6, y: 3.56, z: -1.2 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: 4.7, y: 3.56, z: 0.3 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: 0.8, y: 3.56, z: 0.8 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: -2.3, y: 3.56, z: 0.8 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: -3.5, y: 3.56, z: -0.5 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: -3.5, y: 3.56, z: -2 }, type: ROOM_TYPE.MEETING },
    "7":{ position: { x: 0, y: 3.56, z: -3.5 }, type: ROOM_TYPE.SPEED_NETWORKING },
    "8": { position: { x: 5, y: 3.56, z: -2.9 }, type: ROOM_TYPE.MEETING },
    "9": { position: { x: -8.5, y: 3.56, z: -6.8 }, type: ROOM_TYPE.WEBINAR },
    "10": { position: { x: -0.7, y: 3.56, z: -7.2 }, type: ROOM_TYPE.MEETING },
    "11": { position: { x: -0.7, y: 3.56, z: -8.5 }, type: ROOM_TYPE.MEETING },
    "12": { position: { x: 2.5, y: 3.56, z: -8.5 }, type: ROOM_TYPE.MEETING },
    "13": { position: { x: 2.5, y: 3.56, z: -7.2 }, type: ROOM_TYPE.MEETING },
    "14": { position: { x: 12, y: 3.56, z: -6 }, type: ROOM_TYPE.NORMAL },
    "15": { position: { x:  14.5, y: 3.56, z: -0.6 }, type: ROOM_TYPE.MEETING },
    "16": { position: { x: 14.5, y: 3.56, z: -2 }, type: ROOM_TYPE.MEETING },
    "17": { position: { x: 18, y: 3.56, z: -2 }, type: ROOM_TYPE.MEETING },
    "18": { position: { x: 18, y: 3.56, z: -0.6 }, type: ROOM_TYPE.MEETING },
    "19": { position: { x: 16, y: 3.56, z: 4.9 }, type: ROOM_TYPE.NORMAL },
    "20": { position: { x: 16, y: 3.56, z: 2.7 }, type: ROOM_TYPE.MEETING },
    "21": { position: { x: 19.5, y: 3.56, z: 2.7 }, type: ROOM_TYPE.MEETING },
    "22": { position: { x: 19.5, y: 3.56, z: 4.1 }, type: ROOM_TYPE.MEETING },
    "23": { position: { x: 19.5, y: 3.56, z: 5.5 }, type: ROOM_TYPE.MEETING },
    "24": { position: { x: 19.5, y: 3.56, z: 6.8 }, type: ROOM_TYPE.MEETING },
    "25": { position: { x: 16, y: 3.56, z: 6.8 }, type: ROOM_TYPE.MEETING },
    "26": { position: { x: 12.5, y: 3.56, z: 6.8 }, type: ROOM_TYPE.MEETING },
    "27": { position: { x: 12.5, y: 3.56, z: 5.5}, type: ROOM_TYPE.MEETING },
    "28": { position: { x: 12.5, y: 3.56, z: 4.1 }, type: ROOM_TYPE.MEETING },
    "29": { position: { x: 12.5, y: 3.56, z: 2.7 }, type: ROOM_TYPE.MEETING },
    "30": { position: { x: 1, y: 3.56, z: 6.6 }, type: ROOM_TYPE.NORMAL },
    "31": { position: { x: 1, y: 3.56, z: 4.5 }, type: ROOM_TYPE.MEETING },
    "32": { position: { x: 4.2, y: 3.56, z: 4.5}, type: ROOM_TYPE.MEETING },
    "33": { position: { x: 4.2, y: 3.56, z: 6}, type: ROOM_TYPE.MEETING },
    "34": { position: { x: 4.2, y: 3.56, z: 7.2}, type: ROOM_TYPE.MEETING },
    "35": { position: { x: 4.2, y: 3.56, z: 8.6}, type: ROOM_TYPE.MEETING },
    "36": { position: { x: 1, y: 3.56, z: 8.6}, type: ROOM_TYPE.MEETING },
    "37": { position: { x: -2.2, y: 3.56, z: 8.6}, type: ROOM_TYPE.MEETING },
    "38": { position: { x: -2.2, y: 3.56, z: 7.2}, type: ROOM_TYPE.MEETING },
    "39": { position: { x: -2.2, y: 3.56, z: 6}, type: ROOM_TYPE.MEETING },
    "40": { position: { x: -2.2, y: 3.56, z: 4.5}, type: ROOM_TYPE.MEETING },
    "41": { position: { x: -14.5, y: 3.56, z: 5.4}, type: ROOM_TYPE.NORMAL },
    "42": { position: { x: -14.5, y: 3.56, z: 4}, type: ROOM_TYPE.MEETING },
    "43": { position: { x: -11, y: 3.56, z: 4}, type: ROOM_TYPE.MEETING },
    "44": { position: { x: -11, y: 3.56, z: 5.3}, type: ROOM_TYPE.MEETING },
    "45": { position: { x: -11, y: 3.56, z: 6.6}, type: ROOM_TYPE.MEETING },
    "46": { position: { x: -11, y: 3.56, z: 8}, type: ROOM_TYPE.MEETING },
    "47": { position: { x: -14.5, y: 3.56, z: 8}, type: ROOM_TYPE.MEETING },
    "48": { position: { x: -14.5, y: 3.56, z: 6.6}, type: ROOM_TYPE.MEETING },
    "49": { position: { x: -18, y: 3.56, z: 8}, type: ROOM_TYPE.MEETING },
    "50": { position: { x: -18, y: 3.56, z: 6.6}, type: ROOM_TYPE.MEETING },
    "51": { position: { x: -18, y: 3.56, z: 5.3}, type: ROOM_TYPE.MEETING },
    "52": { position: { x: -18, y: 3.56, z: 4}, type: ROOM_TYPE.MEETING },
    "53": { position: { x: -16.3, y: 3.56, z: -1.5}, type: ROOM_TYPE.MEETING },
    "54": { position: { x: -16.3, y: 3.56, z: -3.3}, type: ROOM_TYPE.MEETING },
    "55": { position: { x: -13, y: 3.56, z: -3.3}, type: ROOM_TYPE.MEETING },
    "56": { position: { x: -13, y: 3.56, z: -1.9 }, type: ROOM_TYPE.MEETING },
    "57": { position: { x: -13, y: 3.56, z: -0.5}, type: ROOM_TYPE.MEETING },
    "58": { position: { x: -13, y: 3.56, z: 0.8}, type: ROOM_TYPE.MEETING },
    "59": { position: { x: -16.3, y: 3.56, z: 0.8}, type: ROOM_TYPE.MEETING },
    "60": { position: { x: -19.4, y: 3.56, z: 0.8}, type: ROOM_TYPE.MEETING },
    "61": { position: { x: -19.4, y: 3.56, z: -0.5}, type: ROOM_TYPE.MEETING },
    "62": { position: { x: -19.4, y: 3.56, z: -1.9}, type: ROOM_TYPE.MEETING },
    "63": { position: { x: -19.4, y: 3.56, z: -3.3}, type: ROOM_TYPE.MEETING },
  },
  ENEB_SPACE_ISLANDS_BLUE: {
    "0": { position: { x: -0.3, y: 3.56, z: -1.5 }, type: ROOM_TYPE.SPEED_NETWORKING },
    "1": { position: { x: 4, y: 3.56, z: -2.5 }, type: ROOM_TYPE.NORMAL },
    "2": { position: { x: 4, y: 3.56, z: -0.5 }, type: ROOM_TYPE.NORMAL },
    "3": { position: { x: -0.3, y: 3.56, z: -3.6 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: -4, y: 3.56, z: -3.6 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: -4.8, y: 3.56, z: -2 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: -4.8, y: 3.56, z: -0.5 }, type: ROOM_TYPE.MEETING },
    "7":{ position: { x: -4, y: 3.56, z: 0.9 }, type: ROOM_TYPE.MEETING },
    "8": { position: { x: -0.3, y: 3.56, z: 0.9 }, type: ROOM_TYPE.MEETING },
    "9": { position: { x: -15, y: 3.56, z: 0.7 }, type: ROOM_TYPE.MEETING },
    "10": { position: { x: -18.5, y: 3.56, z: 0.7 }, type: ROOM_TYPE.MEETING },
    "11": { position: { x: -22, y: 3.56, z: 0.7 }, type: ROOM_TYPE.MEETING },
    "12": { position: { x: -22, y: 3.56, z: -0.6 }, type: ROOM_TYPE.MEETING },
    "13": { position: { x: -22, y: 3.56, z: -2 }, type: ROOM_TYPE.MEETING },
    "14": { position: { x: -22, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "15": { position: { x: -18, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "16": { position: { x: -15, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "17": { position: { x: -18, y: 3.56, z: -1.4 }, type: ROOM_TYPE.NORMAL },
    "18": { position: { x: -12.5, y: 3.56, z: -7.1 }, type: ROOM_TYPE.MEETING },
    "19": { position: { x: -2.1, y: 3.56, z: -7.2 }, type: ROOM_TYPE.MEETING },
    "20": { position: { x: -2.1, y: 3.56, z: -8.5 }, type: ROOM_TYPE.MEETING },
    "21": { position: { x: 1, y: 3.56, z: -8.5 }, type: ROOM_TYPE.MEETING },
    "22": { position: { x: 11, y: 3.56, z: -7.1 }, type: ROOM_TYPE.MEETING },
    "23": { position: { x: 14, y: 3.56, z: -3.6 }, type: ROOM_TYPE.MEETING },
    "24": { position: { x: 17.1, y: 3.56, z: -3.6 }, type: ROOM_TYPE.MEETING },
    "25": { position: { x: 20.5, y: 3.56, z: -3.6 }, type: ROOM_TYPE.MEETING },
    "26": { position: { x: 21, y: 3.56, z: -2.3 }, type: ROOM_TYPE.MEETING },
    "27": { position: { x: 21, y: 3.56, z: -0.8 }, type: ROOM_TYPE.MEETING },
    "28": { position: { x: 21, y: 3.56, z: 0.5 }, type: ROOM_TYPE.MEETING },
    "29": { position: { x: 17.1, y: 3.56, z: 0.5 }, type: ROOM_TYPE.MEETING },
    "30": { position: { x: 14, y: 3.56, z: 0.5 }, type: ROOM_TYPE.MEETING },
    "31": { position: { x: 17, y: 3.56, z: -1.4 }, type: ROOM_TYPE.NORMAL },
    "32": { position: { x: 12, y: 3.56, z: 3.8}, type: ROOM_TYPE.MEETING },
    "33": { position: { x: 3.5, y: 3.56, z: 4.4}, type: ROOM_TYPE.MEETING },
    "34": { position: { x: 3.5, y: 3.56, z: 6}, type: ROOM_TYPE.MEETING },
    "35": { position: { x: 3.5, y: 3.56, z: 7.5}, type: ROOM_TYPE.MEETING },
    "36": { position: { x: 3.5, y: 3.56, z: 9}, type: ROOM_TYPE.MEETING },
    "37": { position: { x: -4, y: 3.56, z: 9}, type: ROOM_TYPE.MEETING },
    "38": { position: { x: -4, y: 3.56, z: 7.5}, type: ROOM_TYPE.MEETING },
    "39": { position: { x: -4, y: 3.56, z: 6}, type: ROOM_TYPE.MEETING },
    "40": { position: { x: -4, y: 3.56, z: 4.4}, type: ROOM_TYPE.MEETING },
    "41": { position: { x: -0.5, y: 3.56, z: 6.6}, type: ROOM_TYPE.NORMAL },
  },
  CTTI_BURRA_CLUB: {
    "0": { position: { x: 0, y: 3.56, z: -4.2 }, type: ROOM_TYPE.WEBINAR },
    "1": { position: { x: 21, y: 3.56, z: 2 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: 10, y: 3.56, z: 2 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: 21, y: 3.56, z: 4.5 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: 10, y: 3.56, z: 4.5 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: -10, y: 3.56, z: 2 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: -21, y: 3.56, z: 2 }, type: ROOM_TYPE.MEETING },
    "7": { position: { x: -10, y: 3.56, z: 4.5 }, type: ROOM_TYPE.MEETING },
    "8": { position: { x: -21, y: 3.56, z: 4.5 }, type: ROOM_TYPE.MEETING },
    "9": { position: { x: 0, y: 3.56, z: 8.2 }, type: ROOM_TYPE.NORMAL },
  },
  SPACE_ENEB: {
    "0": { position: { x: -18.2, y: 3.56, z: 7.2 }, type: ROOM_TYPE.MEETING },
    "1": { position: { x: -12, y: 3.56, z: 7.2 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: -5.2, y: 3.56, z: 7.2 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: 0.4, y: 3.56, z: 7.2 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: 7, y: 3.56, z: 7.2 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: 14, y: 3.56, z: 7.2 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: 20.2, y: 3.56, z: 7.2 }, type: ROOM_TYPE.MEETING },
    "7": { position: { x: -16.5, y: 3.56, z: 2 }, type: ROOM_TYPE.MEETING },
    "8": { position: { x: -1, y: 3.56, z: 2.5 }, type: ROOM_TYPE.MEETING },
    "9": { position: { x: 9, y: 3.56, z: 2 }, type: ROOM_TYPE.MEETING },
    "10": { position: { x: -11, y: 3.56, z: -2.5 }, type: ROOM_TYPE.MEETING },
    "11": { position: { x: -4, y: 3.56, z: -2.5 }, type: ROOM_TYPE.MEETING },
    "12": { position: { x: 1.5, y: 3.56, z: -2.5 }, type: ROOM_TYPE.MEETING },
    "13": { position: { x: 6.6, y: 3.56, z: -2.5 }, type: ROOM_TYPE.MEETING },
    "14": { position: { x: -6, y: 3.56, z: -7 }, type: ROOM_TYPE.MEETING },
    "15": { position: { x: 3, y: 3.56, z: -7 }, type: ROOM_TYPE.MEETING },
    "16": { position: { x: -20.6, y: 3.56, z: -4 }, type: ROOM_TYPE.SPEED_NETWORKING },
    "17": { position: { x: 18, y: 3.56, z: -4 }, type: ROOM_TYPE.WEBINAR },
  },
  SPACE_ISLANDS: {
    "0": { position: { x: 2.5, y: 3.56, z: -1.2 }, type: ROOM_TYPE.WEBINAR },
    "1": { position: { x: 7.5, y: 3.56, z: -2.1 }, type: ROOM_TYPE.NORMAL },
    "2": { position: { x: 7.5, y: 3.56, z: -0.1 }, type: ROOM_TYPE.SPEED_NETWORKING },
    "3": { position: { x: 2.5, y: 3.56, z: -3.2 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: -1.5, y: 3.56, z: -3.2 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: -2.6, y: 3.56, z: -1.9 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: -2.6, y: 3.56, z: -0.4 }, type: ROOM_TYPE.MEETING },
    "7":{ position: { x: -1.5, y: 3.56, z: 0.9 }, type: ROOM_TYPE.MEETING },
    "8": { position: { x: 2.5, y: 3.56, z: 0.9 }, type: ROOM_TYPE.MEETING },
    "9": { position: { x: 18.5, y: 3.56, z: -0.6 }, type: ROOM_TYPE.NORMAL },
    "10": { position: { x: 22, y: 3.56, z: -0.6 }, type: ROOM_TYPE.MEETING },
    "11":{ position: { x: 22, y: 3.56, z: -2 }, type: ROOM_TYPE.MEETING },
    "12":{ position: { x: 18.5, y: 3.56, z: -2 }, type: ROOM_TYPE.MEETING },
    "13":{ position: { x: 16, y: 3.56, z: 4.1 }, type: ROOM_TYPE.NORMAL },
    "14":{ position: { x: 20, y: 3.56, z: 4.1 }, type: ROOM_TYPE.MEETING },
    "15":{ position: { x: 20, y: 3.56, z: 2.8 }, type: ROOM_TYPE.MEETING },
    "16":{ position: { x: 16, y: 3.56, z: 2.8 }, type: ROOM_TYPE.MEETING },
    "17":{ position: { x: 6.5, y: 3.56, z: 4.5 }, type: ROOM_TYPE.MEETING },
    "18":{ position: { x: 6.5, y: 3.56, z: 5.9 }, type: ROOM_TYPE.MEETING },
    "19":{ position: { x: 6.5, y: 3.56, z: 7.3 }, type: ROOM_TYPE.MEETING },
    "20":{ position: { x: 6.5, y: 3.56, z: 8.6 }, type: ROOM_TYPE.MEETING },
    "21":{ position: { x: 2.5, y: 3.56, z: 8.6 }, type: ROOM_TYPE.MEETING },
    "22":{ position: { x: -1.4, y: 3.56, z: 8.6 }, type: ROOM_TYPE.MEETING },
    "23":{ position: { x: -1.4, y: 3.56, z: 7.3 }, type: ROOM_TYPE.MEETING },
    "24":{ position: { x: -1.4, y: 3.56, z: 5.9 }, type: ROOM_TYPE.MEETING },
    "25":{ position: { x: -1.4, y: 3.56, z: 4.5 }, type: ROOM_TYPE.MEETING },
    "26":{ position: { x: 2.5, y: 3.56, z: 4.5 }, type: ROOM_TYPE.MEETING },
    "27":{ position: { x: 2.5, y: 3.56, z: 6.5 }, type: ROOM_TYPE.NORMAL },
    "28":{ position: { x: -13.8, y: 3.56, z: -3.2 }, type: ROOM_TYPE.MEETING },
    "29":{ position: { x: -13.8, y: 3.56, z: -1.8 }, type: ROOM_TYPE.MEETING },
    "30":{ position: { x: -13.8, y: 3.56, z: -0.5 }, type: ROOM_TYPE.MEETING },
    "31":{ position: { x: -13.8, y: 3.56, z: 0.9 }, type: ROOM_TYPE.MEETING },
    "32":{ position: { x: -17.8, y: 3.56, z: 0.9 }, type: ROOM_TYPE.MEETING },
    "33":{ position: { x: -21.8, y: 3.56, z: 0.9 }, type: ROOM_TYPE.MEETING },
    "34":{ position: { x: -21.8, y: 3.56, z: -0.5 }, type: ROOM_TYPE.MEETING },
    "35":{ position: { x: -21.8, y: 3.56, z: -1.8 }, type: ROOM_TYPE.MEETING },
    "36":{ position: { x: -21.8, y: 3.56, z: -3.2 }, type: ROOM_TYPE.MEETING },
    "37":{ position: { x: -17.8, y: 3.56, z: -3.2 }, type: ROOM_TYPE.MEETING },
    "38":{ position: { x: -17.8, y: 3.56, z: -1.2 }, type: ROOM_TYPE.NORMAL },
    "39":{ position: { x: 0.6, y: 3.56, z: -7 }, type: ROOM_TYPE.NORMAL },
    "40":{ position: { x: 4, y: 3.56, z: -7 }, type: ROOM_TYPE.MEETING },
    "41":{ position: { x: 4, y: 3.56, z: -8.3 }, type: ROOM_TYPE.MEETING },
    "42":{ position: { x: 0.6, y: 3.56, z: -8.3 }, type: ROOM_TYPE.MEETING },
    "43":{ position: { x: 15.2, y: 3.56, z: -6 }, type: ROOM_TYPE.NORMAL },
  },
  SPACE_ISLANDS_XRF: {
    "0": { position: { x: 2.5, y: 3.56, z: -1.2 }, type: ROOM_TYPE.WEBINAR },
    "1": { position: { x: 7.5, y: 3.56, z: -2.1 }, type: ROOM_TYPE.NORMAL },
    "2": { position: { x: 7.5, y: 3.56, z: -0.1 }, type: ROOM_TYPE.SPEED_NETWORKING },
    "3": { position: { x: 2.5, y: 3.56, z: -3.2 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: -1.5, y: 3.56, z: -3.2 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: -2.6, y: 3.56, z: -1.9 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: -2.6, y: 3.56, z: -0.4 }, type: ROOM_TYPE.MEETING },
    "7":{ position: { x: -1.5, y: 3.56, z: 0.9 }, type: ROOM_TYPE.MEETING },
    "8": { position: { x: 2.5, y: 3.56, z: 0.9 }, type: ROOM_TYPE.MEETING },
    "9": { position: { x: 18.5, y: 3.56, z: -0.6 }, type: ROOM_TYPE.NORMAL },
    "10": { position: { x: 22, y: 3.56, z: -0.6 }, type: ROOM_TYPE.MEETING },
    "11":{ position: { x: 22, y: 3.56, z: -2 }, type: ROOM_TYPE.MEETING },
    "12":{ position: { x: 18.5, y: 3.56, z: -2 }, type: ROOM_TYPE.MEETING },
    "13":{ position: { x: 16, y: 3.56, z: 4.1 }, type: ROOM_TYPE.NORMAL },
    "14":{ position: { x: 20, y: 3.56, z: 4.1 }, type: ROOM_TYPE.MEETING },
    "15":{ position: { x: 20, y: 3.56, z: 2.8 }, type: ROOM_TYPE.MEETING },
    "16":{ position: { x: 16, y: 3.56, z: 2.8 }, type: ROOM_TYPE.MEETING },
    "17":{ position: { x: 6.5, y: 3.56, z: 4.5 }, type: ROOM_TYPE.MEETING },
    "18":{ position: { x: 6.5, y: 3.56, z: 5.9 }, type: ROOM_TYPE.MEETING },
    "19":{ position: { x: 6.5, y: 3.56, z: 7.3 }, type: ROOM_TYPE.MEETING },
    "20":{ position: { x: 6.5, y: 3.56, z: 8.6 }, type: ROOM_TYPE.MEETING },
    "21":{ position: { x: 2.5, y: 3.56, z: 8.6 }, type: ROOM_TYPE.MEETING },
    "22":{ position: { x: -1.4, y: 3.56, z: 8.6 }, type: ROOM_TYPE.MEETING },
    "23":{ position: { x: -1.4, y: 3.56, z: 7.3 }, type: ROOM_TYPE.MEETING },
    "24":{ position: { x: -1.4, y: 3.56, z: 5.9 }, type: ROOM_TYPE.MEETING },
    "25":{ position: { x: -1.4, y: 3.56, z: 4.5 }, type: ROOM_TYPE.MEETING },
    "26":{ position: { x: 2.5, y: 3.56, z: 4.5 }, type: ROOM_TYPE.MEETING },
    "27":{ position: { x: 2.5, y: 3.56, z: 6.5 }, type: ROOM_TYPE.NORMAL },
    "28":{ position: { x: -13.8, y: 3.56, z: -3.2 }, type: ROOM_TYPE.MEETING },
    "29":{ position: { x: -13.8, y: 3.56, z: -1.8 }, type: ROOM_TYPE.MEETING },
    "30":{ position: { x: -13.8, y: 3.56, z: -0.5 }, type: ROOM_TYPE.MEETING },
    "31":{ position: { x: -13.8, y: 3.56, z: 0.9 }, type: ROOM_TYPE.MEETING },
    "32":{ position: { x: -17.8, y: 3.56, z: 0.9 }, type: ROOM_TYPE.MEETING },
    "33":{ position: { x: -21.8, y: 3.56, z: 0.9 }, type: ROOM_TYPE.MEETING },
    "34":{ position: { x: -21.8, y: 3.56, z: -0.5 }, type: ROOM_TYPE.MEETING },
    "35":{ position: { x: -21.8, y: 3.56, z: -1.8 }, type: ROOM_TYPE.MEETING },
    "36":{ position: { x: -21.8, y: 3.56, z: -3.2 }, type: ROOM_TYPE.MEETING },
    "37":{ position: { x: -17.8, y: 3.56, z: -3.2 }, type: ROOM_TYPE.MEETING },
    "38":{ position: { x: -17.8, y: 3.56, z: -1.2 }, type: ROOM_TYPE.NORMAL },
    "39":{ position: { x: 0.6, y: 3.56, z: -7 }, type: ROOM_TYPE.NORMAL },
    "40":{ position: { x: 4, y: 3.56, z: -7 }, type: ROOM_TYPE.MEETING },
    "41":{ position: { x: 4, y: 3.56, z: -8.3 }, type: ROOM_TYPE.MEETING },
    "42":{ position: { x: 0.6, y: 3.56, z: -8.3 }, type: ROOM_TYPE.MEETING },
    "43":{ position: { x: 15.2, y: 3.56, z: -6 }, type: ROOM_TYPE.NORMAL },
  },
  SHOWROOM_TROPICAL: {
    "0": { position: { x: 14.7, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "1": { position: { x: 9.5, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: 4.4, y: 3.56, z: -3.5 }, type: ROOM_TYPE.NORMAL },
    "3": { position: { x: -0.5, y: 3.56, z: -3.5 }, type: ROOM_TYPE.NORMAL },
    "4": { position: { x: -5.5, y: 3.56, z: -3.5 }, type: ROOM_TYPE.NORMAL },
    "5": { position: { x: -10.5, y: 3.56, z: 0.1 }, type: ROOM_TYPE.NORMAL },
    "6": { position: { x: -2.4, y: 3.56, z: 3.5 }, type: ROOM_TYPE.WEBINAR },
    "7":{ position: { x: 4.4, y: 3.56, z: 3.5 }, type: ROOM_TYPE.NORMAL },
    "8": { position: { x: 9.5, y: 3.56, z: 3.5 }, type: ROOM_TYPE.MEETING },
    "9": { position: { x: 14.7, y: 3.56, z: 3.5 }, type: ROOM_TYPE.MEETING },
    "10": { position: { x: 19, y: 3.56, z: 0.1 }, type: ROOM_TYPE.NORMAL },
    "11":{ position: { x: -19, y: 3.56, z: 0.1 }, type: ROOM_TYPE.NORMAL },
  },
  SHOWROOM_OASIS: {
    "0": { position: { x: 8.7, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "1": { position: { x: 3.5, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: -2.4, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: -7.8, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: -13, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: 8.7, y: 3.56, z: 0.1 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: 3.5, y: 3.56, z: 0.1 }, type: ROOM_TYPE.MEETING },
    "7":{ position: { x: -2.4, y: 3.56, z: 0.1 }, type: ROOM_TYPE.MEETING },
    "8": { position: { x: -7.8, y: 3.56, z: 0.1 }, type: ROOM_TYPE.MEETING },
    "9": { position: { x: -13, y: 3.56, z: 0.1 }, type: ROOM_TYPE.MEETING },
    "10": { position: { x: 8.7, y: 3.56, z: 3.8 }, type: ROOM_TYPE.MEETING },
    "11":{ position: { x: 3.5, y: 3.56, z: 3.8 }, type: ROOM_TYPE.MEETING },
    "12": { position: { x: -2.4, y: 3.56, z: 3.8 }, type: ROOM_TYPE.MEETING },
    "13": { position: { x: -7.8, y: 3.56, z: 3.8 }, type: ROOM_TYPE.MEETING },
    "14": { position: { x: -13, y: 3.56, z: 3.8 }, type: ROOM_TYPE.MEETING },
    "15": { position: { x: 8.7, y: 3.56, z: 7.4 }, type: ROOM_TYPE.MEETING },
    "16": { position: { x: 3.5, y: 3.56, z: 7.4 }, type: ROOM_TYPE.MEETING },
    "17": { position: { x: -2.4, y: 3.56, z: 7.4 }, type: ROOM_TYPE.MEETING },
    "18": { position: { x: -7.8, y: 3.56, z: 7.4 }, type: ROOM_TYPE.MEETING },
    "19": { position: { x: -13, y: 3.56, z: 7.4 }, type: ROOM_TYPE.MEETING },
    "20": { position: { x: -22, y: 3.56, z: -0.8 }, type: ROOM_TYPE.NORMAL },
    "21": { position: { x: -22, y: 3.56, z: 4.2 }, type: ROOM_TYPE.MEETING },
    "22": { position: { x: -6, y: 3.56, z: -7 }, type: ROOM_TYPE.MEETING },
    "23": { position: { x: 18, y: 3.56, z: 0 }, type: ROOM_TYPE.MEETING },
  },
  SHOWROOM_FOREST: {
    "0": { position: { x: -11.5, y: 3.56, z: -6.5 }, type: ROOM_TYPE.MEETING },
    "1": { position: { x: -6, y: 3.56, z: -6.8 }, type: ROOM_TYPE.SPEED_NETWORKING },
    "2": { position: { x: 3.6, y: 3.56, z: -7 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: 14.7, y: 3.56, z: -7.5 }, type: ROOM_TYPE.WEBINAR },
    "4": { position: { x: -5, y: 3.56, z: -1.5 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: 1.5, y: 3.56, z: -1.5 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: 8, y: 3.56, z: -1.5 }, type: ROOM_TYPE.MEETING },
    "7":{ position: { x: 14, y: 3.56, z: -1.5 }, type: ROOM_TYPE.MEETING },
    "8": { position: { x: -5, y: 3.56, z: 1.5 }, type: ROOM_TYPE.MEETING },
    "9": { position: { x: 1.5, y: 3.56, z: 1.5 }, type: ROOM_TYPE.MEETING },
    "10": { position: { x: 8, y: 3.56, z: 1.5 }, type: ROOM_TYPE.MEETING },
    "11":{ position: { x: 14, y: 3.56, z: 1.5 }, type: ROOM_TYPE.MEETING },
    "12": { position: { x: -4.5, y: 3.56, z: 5 }, type: ROOM_TYPE.MEETING },
    "13": { position: { x: -4.5, y: 3.56, z: 8.2 }, type: ROOM_TYPE.MEETING },
    "14": { position: { x: 0.8, y: 3.56, z: 5 }, type: ROOM_TYPE.MEETING },
    "15": { position: { x: 0.8, y: 3.56, z: 8.2 }, type: ROOM_TYPE.MEETING },
    "16": { position: { x: 6, y: 3.56, z: 5 }, type: ROOM_TYPE.MEETING },
    "17": { position: { x: 6, y: 3.56, z: 8.2 }, type: ROOM_TYPE.MEETING },
    "18": { position: { x: 11.5, y: 3.56, z: 5 }, type: ROOM_TYPE.MEETING },
    "19": { position: { x: 11.5, y: 3.56, z: 8.2 }, type: ROOM_TYPE.MEETING },
    "20": { position: { x: 17.5, y: 3.56, z: 5 }, type: ROOM_TYPE.MEETING },
    "21": { position: { x: 17.5, y: 3.56, z: 8.2 }, type: ROOM_TYPE.MEETING },
    "22": { position: { x: -13, y: 3.56, z: 2.3 }, type: ROOM_TYPE.MEETING },
    "23": { position: { x: -19.5, y: 3.56, z: 0 }, type: ROOM_TYPE.MEETING },
  },
  SHOWROOM_SUPER_BIG_WITH_NETWORKING_NO_WALL: {
    "0": { position: { x: 19.5, y: 3.56, z: -3.5 }, type: ROOM_TYPE.NORMAL},
    "1": { position: { x: 15, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: 10, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: 5, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: 0, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: -5.1, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: -11, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "7": { position: { x: -11, y: 3.56, z: 3.5 }, type: ROOM_TYPE.NORMAL },
    "8": { position: { x: -2, y: 3.56, z: 3.5 }, type: ROOM_TYPE.NORMAL },
    "9": { position: { x: 5, y: 3.56, z: 3.5 }, type: ROOM_TYPE.WEBINAR },
    "10": { position: { x: 10, y: 3.56, z: 3.5 }, type: ROOM_TYPE.MEETING },
    "11": { position: { x: 15, y: 3.56, z: 3.5 }, type: ROOM_TYPE.MEETING },
    "12": { position: { x: 19.5, y: 3.56, z: 3.5 }, type: ROOM_TYPE.MEETING },
    "13": { position: { x: -18.30, y: 3.56, z: 0.02 }, type: ROOM_TYPE.NORMAL },
  },
  SHOWROOM_INVESTIGATION: {
    "0": { position: { x: 19.5, y: 3.56, z: -3.5 }, type: ROOM_TYPE.NORMAL},
    "1": { position: { x: 15.5, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: 11, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: 6.5, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: 2, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: -2.5, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: -7, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "7": { position: { x: -12, y: 3.56, z: -3.5 }, type: ROOM_TYPE.NORMAL },
    "8": { position: { x: -12, y: 3.56, z: 3.5 }, type: ROOM_TYPE.NORMAL },
    "9": { position: { x: -5, y: 3.56, z: 3.5 }, type: ROOM_TYPE.WEBINAR },
    "10": { position: { x: 2, y: 3.56, z: 3.5 }, type: ROOM_TYPE.MEETING },
    "11": { position: { x: 6.5, y: 3.56, z: 3.5 }, type: ROOM_TYPE.MEETING },
    "12": { position: { x: 11.5, y: 3.56, z: 3.5 }, type: ROOM_TYPE.MEETING },
    "13": { position: { x: 15.5, y: 3.56, z: 3.5 }, type: ROOM_TYPE.MEETING },
    "14": { position: { x: -18.30, y: 3.56, z: 0.02 }, type: ROOM_TYPE.NORMAL },
  },
  SHOWROOM_SUPER_OFFICE: {
    "0": { position: { x: 21.5, y: 3.56, z: 0.02 }, type: ROOM_TYPE.NORMAL},
    "1": { position: { x: 18.2, y: 3.56, z: -5.2 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: 18.2, y: 3.56, z: -2.7 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: 18.2, y: 3.56, z: -0 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: 18.2, y: 3.56, z: 2.7 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: 18.2, y: 3.56, z: 5.2 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: 11.4, y: 3.56, z: -5.2 }, type: ROOM_TYPE.MEETING },
    "7": { position: { x: 11.4, y: 3.56, z: -2.7 }, type: ROOM_TYPE.MEETING },
    "8": { position: { x: 11.4, y: 3.56, z: -0 }, type: ROOM_TYPE.MEETING },
    "9": { position: { x: 11.4, y: 3.56, z: 2.7 }, type: ROOM_TYPE.MEETING },
    "10": { position: { x: 11.4, y: 3.56, z: 5.2 }, type: ROOM_TYPE.MEETING },
    "11": { position: { x: 7.7, y: 3.56, z: -5.2 }, type: ROOM_TYPE.MEETING },
    "12": { position: { x: 7.7, y: 3.56, z: -2.7 }, type: ROOM_TYPE.MEETING },
    "13": { position: { x: 7.7, y: 3.56, z: -0 }, type: ROOM_TYPE.MEETING },
    "14": { position: { x: 7.7, y: 3.56, z: 2.7 }, type: ROOM_TYPE.MEETING },
    "15": { position: { x: 7.7, y: 3.56, z: 5.2 }, type: ROOM_TYPE.MEETING },
    "16": { position: { x: 1, y: 3.56, z: -5.2 }, type: ROOM_TYPE.MEETING },
    "17": { position: { x: 1, y: 3.56, z: -2.7 }, type: ROOM_TYPE.MEETING },
    "18": { position: { x: 1, y: 3.56, z: -0 }, type: ROOM_TYPE.MEETING },
    "19": { position: { x: 1, y: 3.56, z: 2.7 }, type: ROOM_TYPE.MEETING },
    "20": { position: { x: 1, y: 3.56, z: 5.2 }, type: ROOM_TYPE.MEETING },
    "21": { position: { x: -3, y: 3.56, z: -5.2 }, type: ROOM_TYPE.MEETING },
    "22": { position: { x: -3, y: 3.56, z: -2.7 }, type: ROOM_TYPE.MEETING },
    "23": { position: { x: -3, y: 3.56, z: -0 }, type: ROOM_TYPE.MEETING },
    "24": { position: { x: -3, y: 3.56, z: 2.7 }, type: ROOM_TYPE.MEETING },
    "25": { position: { x: -3, y: 3.56, z: 5.2 }, type: ROOM_TYPE.MEETING },
    "26": { position: { x: -9, y: 3.56, z: -5.2 }, type: ROOM_TYPE.MEETING },
    "27": { position: { x: -9, y: 3.56, z: -2.7 }, type: ROOM_TYPE.MEETING },
    "28": { position: { x: -9, y: 3.56, z: -0 }, type: ROOM_TYPE.MEETING },
    "29": { position: { x: -9, y: 3.56, z: 2.7 }, type: ROOM_TYPE.MEETING },
    "30": { position: { x: -9, y: 3.56, z: 5.2 }, type: ROOM_TYPE.MEETING },
    "31": { position: { x: -13, y: 3.56, z: -2.7 }, type: ROOM_TYPE.MEETING },
    "32": { position: { x: -13, y: 3.56, z: -0 }, type: ROOM_TYPE.MEETING },
    "33": { position: { x: -13, y: 3.56, z: 2.7 }, type: ROOM_TYPE.MEETING },
    "34": { position: { x: -14, y: 3.56, z: -5.2 }, type: ROOM_TYPE.MEETING },
    "35": { position: { x: -14, y: 3.56, z: 5.2 }, type: ROOM_TYPE.MEETING },
    "36": { position: { x: -21.30, y: 3.56, z: 0.02 }, type: ROOM_TYPE.NORMAL },
  },
  SHOWROOM_NETWORKING: {
    "0": { position: { x: 15.5, y: 3.56, z: -3 }, type: ROOM_TYPE.NORMAL},
    "1": { position: { x: 9, y: 3.56, z: -3 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: -1, y: 3.56, z: -3 }, type: ROOM_TYPE.NORMAL },
    "3": { position: { x: -3.5, y: 3.56, z: 3 }, type: ROOM_TYPE.NORMAL },
    "4": { position: { x: 9, y: 3.56, z: 3 }, type: ROOM_TYPE.NORMAL },
    "5": { position: { x: -16.30, y: 3.56, z: 0.02 }, type: ROOM_TYPE.NORMAL },
  },
  SHOWROOM_SUPER_BIG: {
    "0": { position: { x: 19.5, y: 3.56, z: -3.5 }, type: ROOM_TYPE.NORMAL},
    "1": { position: { x: 15, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: 10, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: 5, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: 0, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: -5, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: -11, y: 3.56, z: -3.5 }, type: ROOM_TYPE.NORMAL },
    "7": { position: { x: -11, y: 3.56, z: 3.5 }, type: ROOM_TYPE.NORMAL },
    "8": { position: { x: -2, y: 3.56, z: 3.5 }, type: ROOM_TYPE.WEBINAR },
    "9": { position: { x: 5, y: 3.56, z: 3.5 }, type: ROOM_TYPE.MEETING },
    "10": { position: { x: 10, y: 3.56, z: 3.5 }, type: ROOM_TYPE.MEETING },
    "11": { position: { x: 15, y: 3.56, z: 3.5 }, type: ROOM_TYPE.MEETING },
    "12": { position: { x: -18.30, y: 3.56, z: 0.02 }, type: ROOM_TYPE.NORMAL },
  },
  SHOWROOM_BIG: {
    "0": { position: { x: 18.5, y: 3.56, z: -3.5 }, type: ROOM_TYPE.NORMAL},
    "1": { position: { x: 12, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: 6, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: -0.5, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: -7.5, y: 3.56, z: -3.5 }, type: ROOM_TYPE.NORMAL },
    "5": { position: { x: -7.5, y: 3.56, z: 3.5 }, type: ROOM_TYPE.NORMAL },
    "6": { position: { x: 3, y: 3.56, z: 3.5 }, type: ROOM_TYPE.WEBINAR },
    "7": { position: { x: 12, y: 3.56, z: 3.5 }, type: ROOM_TYPE.MEETING },
    "8": { position: { x: -18.30, y: 3.56, z: 0.02 }, type: ROOM_TYPE.NORMAL },
  },
  SHOWROOM_LARGE: {
    "0": { position: { x: 16.5, y: 3.56, z: -3.5 }, type: ROOM_TYPE.NORMAL},
    "1": { position: { x: 10, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: 3, y: 3.56, z: -3.5 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: -4.5, y: 3.56, z: -3.5 }, type: ROOM_TYPE.NORMAL },
    "4": { position: { x: -4.5, y: 3.56, z: 3.5 }, type: ROOM_TYPE.NORMAL },
    "5": { position: { x: 6, y: 3.56, z: 3.5 }, type: ROOM_TYPE.WEBINAR },
    "6": { position: { x: -15.30, y: 3.56, z: 0.02 }, type: ROOM_TYPE.NORMAL },
  },
  SHOWROOM_NORMAL: {
    "0": { position: { x: 16.5, y: 3.56, z: -6.07 }, type: ROOM_TYPE.NORMAL},
    "1": { position: { x: 10, y: 3.56, z: -6.07 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: 3, y: 3.56, z: -6.07 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: -4.5, y: 3.56, z: -6.07 }, type: ROOM_TYPE.NORMAL },
    "4": { position: { x: -4.5, y: 3.56, z: 6.02 }, type: ROOM_TYPE.NORMAL },
    "5": { position: { x: 3, y: 3.56, z: 6.02 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: 10.30, y: 3.56, z: 6.02 }, type: ROOM_TYPE.MEETING },
    "7": { position: { x: -15.30, y: 3.56, z: 0.02 }, type: ROOM_TYPE.NORMAL },
  },
  SHOWROOM_VERY_SMALL: {
    "0": { position: { x: 14.5, y: 3.56, z: -5.07 }, type: ROOM_TYPE.NORMAL},
    "1": { position: { x: 7, y: 3.56, z: -5.07 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: -2, y: 3.56, z: -5.07 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: 13.5, y: 3.56, z: 4.02 }, type: ROOM_TYPE.NORMAL },
    "4": { position: { x: 4, y: 3.56, z: 4.02 }, type: ROOM_TYPE.NORMAL },
    "5": { position: { x: -3, y: 3.56, z: 4.02 }, type: ROOM_TYPE.NORMAL },
    "6": { position: { x: -15.30, y: 3.56, z: 0.02 }, type: ROOM_TYPE.NORMAL },
  },
  SHOWROOM_SMALL: {
    "0": { position: { x: -16.50, y: 3.56, z: 5.07 }, type: ROOM_TYPE.NORMAL},
    "1": { position: { x: -10.00, y: 3.56, z: 5.07 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: -3.97, y: 3.56, z: 5.07 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: 1.95, y: 3.56, z: 5.07 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: -13.56, y: 3.56, z: -4.02 }, type: ROOM_TYPE.NORMAL },
    "5": { position: { x: -3.44, y: 3.56, z: -4.02 }, type: ROOM_TYPE.NORMAL },
    "6": { position: { x: 2.49, y: 3.56, z: -4.02 }, type: ROOM_TYPE.NORMAL },
    "7": { position: { x: 15.30, y: 3.56, z: 0.02 }, type: ROOM_TYPE.NORMAL },
  },
  HAWKINGS_LARGE: {
    "0": {
      position: { x: 16.01, y: 3.56, z: -1.49 },
      type: ROOM_TYPE.WEBINAR,
    },
    "1": { position: { x: 8.61, y: 3.56, z: 12.68 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: 8.61, y: 3.56, z: 7.16 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: 8.61, y: 3.56, z: 2.17 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: 1.19, y: 3.56, z: 8.53 }, type: ROOM_TYPE.NORMAL },
    "5": { position: { x: -6.58, y: 3.56, z: 8.53 }, type: ROOM_TYPE.NORMAL },
    "6": { position: { x: -14.0, y: 3.56, z: 8.53 }, type: ROOM_TYPE.TEACHER },
    "7": {
      position: { x: -23.87, y: 3.56, z: 8.53 },
      type: ROOM_TYPE.MEETING,
    },
    "8": {
      position: { x: -36.84, y: 3.56, z: 8.53 },
      type: ROOM_TYPE.MEETING,
    },
    "9": {
      position: { x: -46.52, y: 3.56, z: 8.53 },
      type: ROOM_TYPE.MEETING,
    },
    "10": {
      position: { x: -60.9, y: 3.56, z: 12.59 },
      type: ROOM_TYPE.MEETING,
    },
    "11": {
      position: { x: -60.9, y: 3.56, z: 7.48 },
      type: ROOM_TYPE.MEETING,
    },
    "12": {
      position: { x: -60.9, y: 3.56, z: 2.24 },
      type: ROOM_TYPE.MEETING,
    },
    "13": {
      position: { x: -57.95, y: 3.56, z: -8.87 },
      type: ROOM_TYPE.NORMAL,
    },
    "14": {
      position: { x: -52.78, y: 3.56, z: -8.87 },
      type: ROOM_TYPE.NORMAL,
    },
    "15": {
      position: { x: -47.81, y: 3.56, z: -8.87 },
      type: ROOM_TYPE.NORMAL,
    },
    "16": {
      position: { x: -42.64, y: 3.56, z: -8.87 },
      type: ROOM_TYPE.NORMAL,
    },
    "17": {
      position: { x: -37.63, y: 3.56, z: -8.87 },
      type: ROOM_TYPE.NORMAL,
    },
    "18": {
      position: { x: -32.58, y: 3.56, z: -8.87 },
      type: ROOM_TYPE.NORMAL,
    },
    "19": {
      position: { x: -25.03, y: 3.56, z: -8.87 },
      type: ROOM_TYPE.SPEED_NETWORKING,
    },
    "20": {
      position: { x: -17.3, y: 3.56, z: -8.87 },
      type: ROOM_TYPE.NORMAL,
    },
    "21": {
      position: { x: -12.41, y: 3.56, z: -8.87 },
      type: ROOM_TYPE.NORMAL,
    },
    "22": {
      position: { x: -7.2, y: 3.56, z: -8.87 },
      type: ROOM_TYPE.NORMAL,
    },
    "23": {
      position: { x: -2.6, y: 3.56, z: -8.87 },
      type: ROOM_TYPE.NORMAL,
    },
    "24": { position: { x: 2.4, y: 3.56, z: -8.9 }, type: ROOM_TYPE.NORMAL },
    "25": {
      position: { x: 8.87, y: 3.56, z: -13.68 },
      type: ROOM_TYPE.NORMAL,
    },
    "26": {
      position: { x: -6.86, y: 3.56, z: 13.43 },
      type: ROOM_TYPE.MEETING,
    },
  },
  OFFICE_PLATFORM_NORMAL_TWO: {
    "0": { position: { x: 36, y: 0, z: 30 }, type: ROOM_TYPE.MEETING },
    "1": { position: { x: 9, y: 1, z: 30 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: -19, y: 2, z: 30 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: -50, y: 3, z: 30 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: -79, y: 4, z: 30 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: 41, y: 5, z: 5 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: 22, y: 6, z: 5 }, type: ROOM_TYPE.MEETING },
    "7": { position: { x: -13, y: 7, z: -2 }, type: ROOM_TYPE.MEETING },
    "8": { position: { x: -7, y: 8, z: 2 }, type: ROOM_TYPE.MEETING },
    "9": { position: { x: -13, y: 9, z: 8 }, type: ROOM_TYPE.MEETING },
    "10": { position: { x: -18, y: 10, z: 2 }, type: ROOM_TYPE.MEETING },
    "11": { position: { x: -46, y: 11, z: 3 }, type: ROOM_TYPE.MEETING },
    "12": { position: { x: -65, y: 12, z: 3 }, type: ROOM_TYPE.MEETING },
    "13": { position: { x: -84, y: 13, z: 3 }, type: ROOM_TYPE.MEETING },
    "14": { position: { x: -83, y: 14, z: -25 }, type: ROOM_TYPE.MEETING },
    "15": { position: { x: -65, y: 15, z: -25 }, type: ROOM_TYPE.MEETING },
    "16": { position: { x: -46, y: 16, z: -25 }, type: ROOM_TYPE.MEETING },
    "17": { position: { x: -20, y: 17, z: -25 }, type: ROOM_TYPE.MEETING },
    "18": { position: { x: 9, y: 18, z: -25 }, type: ROOM_TYPE.MEETING },
    "19": { position: { x: 39, y: 19, z: -25 }, type: ROOM_TYPE.MEETING },
  },
  GAMING_PLATFORM: {
    "0": { position: { x: 0, y: 0, z: 76.8 }, type: ROOM_TYPE.WEBINAR },
    "1": { position: { x: 32, y: 1, z: 82 }, type: ROOM_TYPE.SPEED_NETWORKING },
    "2": { position: { x: 34.5, y: 2, z: 17 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: 27.5, y: 3, z: 17 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: 20.5, y: 4, z: 17 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: 14, y: 5, z: 17 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: 7, y: 6, z: 17 }, type: ROOM_TYPE.MEETING },
    "7": { position: { x: 0, y: 7, z: 17 }, type: ROOM_TYPE.MEETING },
    "8": { position: { x: -7, y: 8, z: 17 }, type: ROOM_TYPE.MEETING },
    "9": { position: { x: -14, y: 9, z: 17 }, type: ROOM_TYPE.MEETING },
    "10": { position: { x: -21, y: 10, z: 17 }, type: ROOM_TYPE.MEETING },
    "11": { position: { x: -21.5, y: 11, z: 38.5 }, type: ROOM_TYPE.GAME },
    "12": { position: { x: -14, y: 12, z: 38.5 }, type: ROOM_TYPE.GAME },
    "13": { position: { x: -6.5, y: 13, z: 38.5 }, type: ROOM_TYPE.GAME },
    "14": { position: { x: 1.5, y: 14, z: 38.5 }, type: ROOM_TYPE.GAME },
    "15": { position: { x: -21.5, y: 15, z: 32.5 }, type: ROOM_TYPE.GAME },
    "16": { position: { x: -14, y: 16, z: 32.5 }, type: ROOM_TYPE.GAME },
    "17": { position: { x: -6.5, y: 17, z: 32.5 }, type: ROOM_TYPE.GAME },
    "18": { position: { x: 1.5, y: 17, z: 32.5 }, type: ROOM_TYPE.GAME },
    "19": { position: { x: 30, y: 19, z: 35 }, type: ROOM_TYPE.MEETING },
  },
  LEARNING_PLATFORM: {
    "0": { position: { x: -40.91, y: 0, z: -45 }, type: ROOM_TYPE.WEBINAR },
    "1": { position: { x: -2, y: 1, z: -45 }, type: ROOM_TYPE.WEBINAR },
    "2": {
      position: { x: 32, y: 2, z: -45 },
      type: ROOM_TYPE.SPEED_NETWORKING,
    },
    "3": { position: { x: 24, y: 3, z: 11 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: 11, y: 4, z: 11 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: -1, y: 5, z: 11 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: -14, y: 6, z: 11 }, type: ROOM_TYPE.MEETING },
    "7": { position: { x: -26, y: 7, z: 11 }, type: ROOM_TYPE.MEETING },
    "8": { position: { x: -39, y: 8, z: 11 }, type: ROOM_TYPE.MEETING },
    "9": { position: { x: 18, y: 9, z: 60 }, type: ROOM_TYPE.MEETING },
    "10": { position: { x: 8, y: 10, z: 60 }, type: ROOM_TYPE.MEETING },
    "11": { position: { x: -3, y: 11, z: 60 }, type: ROOM_TYPE.MEETING },
    "12": { position: { x: -14, y: 12, z: 60 }, type: ROOM_TYPE.MEETING },
    "13": { position: { x: -25, y: 13, z: 60 }, type: ROOM_TYPE.MEETING },
    "14": { position: { x: -36, y: 14, z: 60 }, type: ROOM_TYPE.MEETING },
    "15": { position: { x: -32, y: 15, z: 35 }, type: ROOM_TYPE.MEETING },
    "16": { position: { x: 28, y: 16, z: 60 }, type: ROOM_TYPE.MEETING },
    "17": { position: { x: 34, y: 17, z: 60 }, type: ROOM_TYPE.GAME },
    "18": { position: { x: 40, y: 18, z: 60 }, type: ROOM_TYPE.GAME },
  },
  AUDITORIUM_MINI: {
    "0": { position: { x: -14, y: 0, z: -1 }, type: ROOM_TYPE.WEBINAR },
    "1": { position: { x: -58, y: 1, z: 15 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: -58, y: 2, z: 4 }, type: ROOM_TYPE.MEETING },
    "3": {
      position: { x: -58, y: 3, z: -10 },
      type: ROOM_TYPE.SPEED_NETWORKING,
    },
  },
  OFFICE_PLATFORM_NORMAL: {
    "0": { position: { x: -13, y: 0, z: 65 }, type: ROOM_TYPE.WEBINAR },
    "1": { position: { x: 29, y: 1, z: 67 }, type: ROOM_TYPE.SPEED_NETWORKING },
    "2": { position: { x: 19, y: 2, z: 55 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: 28, y: 3, z: 55 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: 33, y: 4, z: 25 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: 23.5, y: 5, z: 25 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: 14.5, y: 6, z: 25 }, type: ROOM_TYPE.MEETING },
    "7": { position: { x: 5.5, y: 7, z: 25 }, type: ROOM_TYPE.MEETING },
    "8": { position: { x: -4, y: 8, z: 25 }, type: ROOM_TYPE.MEETING },
    "9": { position: { x: -13, y: 9, z: 25 }, type: ROOM_TYPE.MEETING },
    "10": { position: { x: -22, y: 10, z: 25 }, type: ROOM_TYPE.MEETING },
    "11": { position: { x: -31.5, y: 11, z: 25 }, type: ROOM_TYPE.MEETING },
    "12": { position: { x: -40.5, y: 12, z: 25 }, type: ROOM_TYPE.MEETING },
    "13": { position: { x: -41, y: 13, z: 42 }, type: ROOM_TYPE.NORMAL },
    "14": { position: { x: -33, y: 14, z: 42 }, type: ROOM_TYPE.NORMAL },
    "15": { position: { x: -41, y: 15, z: 37.5 }, type: ROOM_TYPE.NORMAL },
    "16": { position: { x: -33, y: 16, z: 37.5 }, type: ROOM_TYPE.NORMAL },
    "17": { position: { x: -13, y: 17, z: 40 }, type: ROOM_TYPE.NORMAL },
    "18": { position: { x: 18.5, y: 18, z: 39 }, type: ROOM_TYPE.NORMAL },
  },
  WEBINAR_SPEED_NETWORKING_PLATFORM: {
    "0": { position: { x: -10, y: 0, z: -15 }, type: ROOM_TYPE.WEBINAR },
    "1": { position: { x: 5, y: 1, z: -15 }, type: ROOM_TYPE.SPEED_NETWORKING },
    "2": { position: { x: 15, y: 2, z: 10 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: 15, y: 3, z: -7 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: 15, y: 4, z: -25 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: 15, y: 5, z: -42 }, type: ROOM_TYPE.MEETING },
  },
  LAKE_SINGLE_WEBINAR_LARGE_WITH_BOOTHS: {
    "0": { position: { x: -90, y: 0, z: 29 }, type: ROOM_TYPE.MEETING },
    "1": { position: { x: -90, y: 1, z: 15 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: -90, y: 2, z: 2 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: -90, y: 3, z: -12 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: -70, y: 4, z: 29 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: -70, y: 5, z: 15 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: -70, y: 6, z: 2 }, type: ROOM_TYPE.MEETING },
    "7": { position: { x: -70, y: 7, z: -12 }, type: ROOM_TYPE.MEETING },
    "8": { position: { x: -50, y: 8, z: 29 }, type: ROOM_TYPE.MEETING },
    "9": { position: { x: -50, y: 9, z: 15 }, type: ROOM_TYPE.MEETING },
    "10": { position: { x: -50, y: 10, z: 2 }, type: ROOM_TYPE.MEETING },
    "11": { position: { x: -50, y: 11, z: -12 }, type: ROOM_TYPE.MEETING },
    "12": { position: { x: -30, y: 12, z: -28 }, type: ROOM_TYPE.MEETING },
    "13": { position: { x: -30, y: 13, z: -45 }, type: ROOM_TYPE.MEETING },
    "14": { position: { x: -30, y: 14, z: -63 }, type: ROOM_TYPE.MEETING },
    "15": { position: { x: -4, y: 15, z: -28 }, type: ROOM_TYPE.MEETING },
    "16": { position: { x: -4, y: 16, z: -45 }, type: ROOM_TYPE.MEETING },
    "17": { position: { x: -4, y: 17, z: -63 }, type: ROOM_TYPE.MEETING },
    "18": { position: { x: 22, y: 18, z: -28 }, type: ROOM_TYPE.MEETING },
    "19": { position: { x: 22, y: 19, z: -45 }, type: ROOM_TYPE.MEETING },
    "20": { position: { x: 22, y: 20, z: -63 }, type: ROOM_TYPE.MEETING },
    "21": { position: { x: 11, y: 21, z: 29 }, type: ROOM_TYPE.MEETING },
    "22": { position: { x: 32, y: 22, z: 29 }, type: ROOM_TYPE.MEETING },
    "23": { position: { x: 11, y: 23, z: 15 }, type: ROOM_TYPE.MEETING },
    "24": { position: { x: 32, y: 24, z: 15 }, type: ROOM_TYPE.MEETING },
    "25": { position: { x: 11, y: 25, z: 2 }, type: ROOM_TYPE.MEETING },
    "26": { position: { x: 32, y: 26, z: 2 }, type: ROOM_TYPE.MEETING },
    "27": { position: { x: 11, y: 27, z: -12 }, type: ROOM_TYPE.MEETING },
    "28": { position: { x: 32, y: 28, z: -12 }, type: ROOM_TYPE.MEETING },
    "29": { position: { x: -50, y: 15, z: -56 }, type: ROOM_TYPE.MEETING },
    "30": { position: { x: -20, y: 30, z: 11 }, type: ROOM_TYPE.WEBINAR },
  },
  AUDITORIUM: {
    "0": { position: { x: -15, y: 0, z: 0.5 }, type: ROOM_TYPE.WEBINAR },
  },
  RECREATIVE: {
    "0": { position: { x: 14, y: 0, z: 0 }, type: ROOM_TYPE.MEETING },
    "1": { position: { x: -16.15, y: 1.0, z: -7.5 }, type: ROOM_TYPE.GAME },
    "2": { position: { x: -11.15, y: 2.0, z: -7.5 }, type: ROOM_TYPE.GAME },
    "3": { position: { x: -6.1, y: 3.0, z: -7.55 }, type: ROOM_TYPE.GAME },
    "4": { position: { x: -0.93, y: 4.0, z: -7.55 }, type: ROOM_TYPE.GAME },
    "5": { position: { x: 3.87, y: 5.0, z: -7.55 }, type: ROOM_TYPE.GAME },
    "6": { position: { x: 8.87, y: 6.0, z: -7.55 }, type: ROOM_TYPE.GAME },
    "7": { position: { x: 6.66, y: 10.0, z: 5.15 }, type: ROOM_TYPE.GAME },
    "8": { position: { x: 1.66, y: 9.0, z: 5.15 }, type: ROOM_TYPE.GAME },
    "9": { position: { x: -3.3, y: 8.0, z: 5.15 }, type: ROOM_TYPE.GAME },
    "10": { position: { x: -8.3, y: 7.0, z: 5.15 }, type: ROOM_TYPE.GAME },
  },
  CONFERENCE_WEBINAR_SPEED_NETWORKING: {
    "0": {
      position: { x: -10.32, y: 0.0, z: -1.96 },
      type: ROOM_TYPE.WEBINAR,
    },
    "1": { position: { x: 24.12, y: 1.0, z: -17.11 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: 24.12, y: 2.0, z: -6.98 }, type: ROOM_TYPE.MEETING },
    "3": {
      position: { x: 24.12, y: 3, z: 7.8 },
      type: ROOM_TYPE.SPEED_NETWORKING,
    },
    "4": { position: { x: 9.18, y: 4.0, z: 15.24 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: 9.18, y: 5.0, z: 10.29 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: 9.18, y: 6.0, z: 5.25 }, type: ROOM_TYPE.MEETING },
    "7": { position: { x: 9.18, y: 7.0, z: 0.28 }, type: ROOM_TYPE.MEETING },
    "8": { position: { x: 9.18, y: 8.0, z: -4.66 }, type: ROOM_TYPE.MEETING },
    "9": { position: { x: 9.18, y: 9.0, z: -9.57 }, type: ROOM_TYPE.MEETING },
    "10": {
      position: { x: 9.18, y: 11.0, z: -14.67 },
      type: ROOM_TYPE.MEETING,
    },
    "11": {
      position: { x: 9.18, y: 12.0, z: -19.63 },
      type: ROOM_TYPE.MEETING,
    },
  },
  CONFERENCE_WEBINAR: {
    "0": {
      position: { x: -10.32, y: 0.0, z: 0.96 },
      type: ROOM_TYPE.WEBINAR,
    },
    "1": { position: { x: 24.12, y: 1.0, z: -15.11 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: 24.12, y: 2.0, z: -4.98 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: 24.12, y: 3.0, z: 5.07 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: 24.12, y: 4.0, z: 14.83 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: 9.18, y: 5.0, z: 17.24 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: 9.18, y: 6.0, z: 12.29 }, type: ROOM_TYPE.MEETING },
    "7": { position: { x: 9.18, y: 7.0, z: 7.25 }, type: ROOM_TYPE.MEETING },
    "8": { position: { x: 9.18, y: 8.0, z: 2.28 }, type: ROOM_TYPE.MEETING },
    "9": { position: { x: 9.18, y: 9.0, z: -2.66 }, type: ROOM_TYPE.MEETING },
    "10": { position: { x: 9.18, y: 10.0, z: -7.57 }, type: ROOM_TYPE.MEETING },
    "11": {
      position: { x: 9.18, y: 11.0, z: -12.67 },
      type: ROOM_TYPE.MEETING,
    },
    "12": {
      position: { x: 9.18, y: 12.0, z: -17.63 },
      type: ROOM_TYPE.MEETING,
    },
  },
  CONFERENCE_COFFEE: {
    "0": {
      position: { x: -12.21, y: 0.0, z: 1.01 },
      type: ROOM_TYPE.SPEED_NETWORKING,
    },
    "1": { position: { x: 24.12, y: 1.0, z: -15.11 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: 24.12, y: 2.0, z: -4.98 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: 24.12, y: 3.0, z: 5.07 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: 24.12, y: 4.0, z: 14.83 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: 9.18, y: 5.0, z: 17.24 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: 9.18, y: 6.0, z: 12.29 }, type: ROOM_TYPE.MEETING },
    "7": { position: { x: 9.18, y: 7.0, z: 7.25 }, type: ROOM_TYPE.MEETING },
    "8": { position: { x: 9.18, y: 8.0, z: 2.28 }, type: ROOM_TYPE.MEETING },
    "9": { position: { x: 9.18, y: 9.0, z: -2.66 }, type: ROOM_TYPE.MEETING },
    "10": { position: { x: 9.18, y: 10.0, z: -7.57 }, type: ROOM_TYPE.MEETING },
    "11": {
      position: { x: 9.18, y: 11.0, z: -12.67 },
      type: ROOM_TYPE.MEETING,
    },
    "12": {
      position: { x: 9.18, y: 12.0, z: -17.63 },
      type: ROOM_TYPE.MEETING,
    },
  },
  AUTOMOTIVE: {
    "0": { position: { x: 11.79, y: 3.56, z: -7.5 }, type: ROOM_TYPE.NORMAL },
    "1": { position: { x: 21.71, y: 3.56, z: -2.68 }, type: ROOM_TYPE.NORMAL },
    "2": { position: { x: 14.19, y: 3.56, z: 6.23 }, type: ROOM_TYPE.WEBINAR },
    "3": { position: { x: 5.55, y: 3.56, z: 6.23 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: 4.11, y: 3.56, z: -3.7 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: 1.62, y: 3.56, z: -12.65 }, type: ROOM_TYPE.NORMAL },
    "6": { position: { x: -8.95, y: 3.56, z: -3.12 }, type: ROOM_TYPE.MEETING },
    "7": {
      position: { x: -21.54, y: 3.56, z: -4.58 },
      type: ROOM_TYPE.MEETING,
    },
    "8": { position: { x: -25.36, y: 3.56, z: 2.41 }, type: ROOM_TYPE.MEETING },
    "9": { position: { x: -33.05, y: 3.56, z: 2.41 }, type: ROOM_TYPE.MEETING },
    "10": { position: { x: -40.51, y: 3.56, z: -3.7 }, type: ROOM_TYPE.NORMAL },
    "11": {
      position: { x: -40.51, y: 3.56, z: -14.3 },
      type: ROOM_TYPE.MEETING,
    },
    "12": {
      position: { x: -33.83, y: 3.56, z: -14.9 },
      type: ROOM_TYPE.MEETING,
    },
    "13": {
      position: { x: -29.83, y: 3.56, z: -6.56 },
      type: ROOM_TYPE.NORMAL,
    },
    "14": {
      position: { x: -18.32, y: 3.56, z: -14.84 },
      type: ROOM_TYPE.NORMAL,
    },
    "15": {
      position: { x: 20.63, y: 3.56, z: -11.41 },
      type: ROOM_TYPE.NORMAL,
    },
    "16": {
      position: { x: 11.99, y: 3.56, z: -12.33 },
      type: ROOM_TYPE.NORMAL,
    },
    "17": {
      position: { x: 8.9, y: 3.56, z: -1.7 },
      type: ROOM_TYPE.MEETING,
    },
  },
  CONFERENCE_CENTER: {
    "0": {
      position: { x: 24.25, y: 3.57, z: -15.03 },
      type: ROOM_TYPE.MEETING,
    },
    "1": { position: { x: 24.25, y: 3.57, z: -5.07 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: 24.24, y: 3.57, z: 4.76 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: 24.25, y: 3.57, z: 14.84 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: 9.27, y: 3.57, z: 18.54 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: 9.27, y: 3.57, z: 12.11 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: 9.27, y: 3.57, z: 7.14 }, type: ROOM_TYPE.MEETING },
    "7": { position: { x: 9.27, y: 3.57, z: 2.38 }, type: ROOM_TYPE.MEETING },
    "8": { position: { x: 9.27, y: 3.57, z: -2.65 }, type: ROOM_TYPE.MEETING },
    "9": { position: { x: 9.27, y: 3.57, z: -7.97 }, type: ROOM_TYPE.MEETING },
    "10": {
      position: { x: 9.27, y: 3.57, z: -12.39 },
      type: ROOM_TYPE.MEETING,
    },
    "11": {
      position: { x: 9.27, y: 3.57, z: -17.87 },
      type: ROOM_TYPE.MEETING,
    },
    "12": { position: { x: -9.0, y: 3.57, z: 1.3 }, type: ROOM_TYPE.WEBINAR },
    "13": { position: { x: -43.2, y: 3.57, z: 11.0 }, type: ROOM_TYPE.MEETING },
    "14": { position: { x: -43.6, y: 3.57, z: 1.1 }, type: ROOM_TYPE.MEETING },
    "15": { position: { x: -43.3, y: 3.57, z: -9.9 }, type: ROOM_TYPE.MEETING },
    "16": { position: { x: -51.6, y: 3.57, z: 11.1 }, type: ROOM_TYPE.MEETING },
    "17": { position: { x: -52.0, y: 3.57, z: 1.2 }, type: ROOM_TYPE.MEETING },
    "18": { position: { x: -51.7, y: 3.57, z: -9.8 }, type: ROOM_TYPE.MEETING },
    "19": { position: { x: -64.1, y: 3.57, z: 11.2 }, type: ROOM_TYPE.MEETING },
    "20": { position: { x: -64.5, y: 3.57, z: 1.3 }, type: ROOM_TYPE.MEETING },
    "21": { position: { x: -64.2, y: 3.57, z: -9.7 }, type: ROOM_TYPE.MEETING },
    "22": { position: { x: -71.8, y: 3.57, z: 11.3 }, type: ROOM_TYPE.MEETING },
    "23": { position: { x: -72.2, y: 3.57, z: 1.4 }, type: ROOM_TYPE.MEETING },
    "24": { position: { x: -71.9, y: 3.57, z: -9.6 }, type: ROOM_TYPE.MEETING },
    "25": { position: { x: -81.7, y: 3.57, z: 15.7 }, type: ROOM_TYPE.NORMAL },
    "26": { position: { x: -81.8, y: 3.57, z: 0.9 }, type: ROOM_TYPE.NORMAL },
    "27": { position: { x: -82.1, y: 3.57, z: -13.9 }, type: ROOM_TYPE.NORMAL },
    "28": {
      position: { x: -29.96, y: 3.56, z: 0.12 },
      type: ROOM_TYPE.SPEED_NETWORKING,
    },
  },
  CONFERENCE_CENTER_LARGE: {
    "0": { position: { x: 8.1, y: 3.56, z: -13.0 }, type: ROOM_TYPE.MEETING },
    "1": { position: { x: 7.8, y: 3.56, z: 56.3 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: -1.9, y: 3.56, z: -12.8 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: -1.5, y: 3.56, z: 56.4 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: -17.2, y: 5.37, z: 0.5 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: -15.8, y: 5.37, z: 41.0 }, type: ROOM_TYPE.WEBINAR },
    "6": { position: { x: -43.2, y: 5.37, z: 51.9 }, type: ROOM_TYPE.MEETING },
    "7": { position: { x: -43.6, y: 5.37, z: 41.8 }, type: ROOM_TYPE.MEETING },
    "8": { position: { x: -43.8, y: 5.37, z: 30.8 }, type: ROOM_TYPE.MEETING },
    "9": { position: { x: -44.0, y: 5.37, z: 11.7 }, type: ROOM_TYPE.MEETING },
    "10": { position: { x: -43.7, y: 5.37, z: 1.1 }, type: ROOM_TYPE.MEETING },
    "11": { position: { x: -43.7, y: 5.37, z: -9.7 }, type: ROOM_TYPE.MEETING },
    "12": { position: { x: -51.5, y: 5.37, z: 51.8 }, type: ROOM_TYPE.MEETING },
    "13": { position: { x: -51.2, y: 5.37, z: 41.7 }, type: ROOM_TYPE.MEETING },
    "14": { position: { x: -51.6, y: 5.37, z: 30.5 }, type: ROOM_TYPE.MEETING },
    "15": { position: { x: -51.7, y: 5.37, z: 11.4 }, type: ROOM_TYPE.MEETING },
    "16": { position: { x: -51.5, y: 5.37, z: 1.1 }, type: ROOM_TYPE.MEETING },
    "17": { position: { x: -51.9, y: 5.37, z: -9.4 }, type: ROOM_TYPE.MEETING },
    "18": { position: { x: -64.1, y: 5.37, z: 52.2 }, type: ROOM_TYPE.MEETING },
    "19": { position: { x: -64.1, y: 5.37, z: 41.6 }, type: ROOM_TYPE.MEETING },
    "20": { position: { x: -64.1, y: 5.37, z: 30.7 }, type: ROOM_TYPE.MEETING },
    "21": { position: { x: -63.6, y: 5.37, z: 11.5 }, type: ROOM_TYPE.MEETING },
    "22": { position: { x: -63.8, y: 5.37, z: 1.3 }, type: ROOM_TYPE.MEETING },
    "23": { position: { x: -64.5, y: 5.37, z: -9.4 }, type: ROOM_TYPE.MEETING },
    "24": { position: { x: -71.7, y: 5.37, z: 52.0 }, type: ROOM_TYPE.MEETING },
    "25": { position: { x: -72.0, y: 5.37, z: 41.5 }, type: ROOM_TYPE.MEETING },
    "26": { position: { x: -71.7, y: 5.37, z: 30.7 }, type: ROOM_TYPE.MEETING },
    "27": { position: { x: -72.1, y: 5.37, z: 11.7 }, type: ROOM_TYPE.MEETING },
    "28": { position: { x: -71.8, y: 5.37, z: 1.3 }, type: ROOM_TYPE.MEETING },
    "29": { position: { x: -71.8, y: 5.37, z: -9.6 }, type: ROOM_TYPE.MEETING },
    "30": { position: { x: -81.8, y: 3.56, z: 36.1 }, type: ROOM_TYPE.NORMAL },
    "31": { position: { x: -82.1, y: 3.56, z: 20.9 }, type: ROOM_TYPE.NORMAL },
    "32": { position: { x: -82.2, y: 3.56, z: 6.4 }, type: ROOM_TYPE.NORMAL },
    "33": {
      position: { x: 0.7, y: 0.0, z: 21.4 },
      type: ROOM_TYPE.SPEED_NETWORKING,
    },
  },
  LAKE_SINGLE_WEBINAR: {
    "0": { position: { x: -25.87, y: 0.0, z: -6.8 }, type: ROOM_TYPE.MEETING },
    "1": { position: { x: -45.68, y: 1.0, z: -4.51 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: -49.78, y: 2.0, z: 14.61 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: -31.94, y: 3.0, z: 8.38 }, type: ROOM_TYPE.MEETING },
    "4": { position: { x: -7.2, y: 4.0, z: 25.1 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: 9.2, y: 5.0, z: 29.2 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: -7.4, y: 6.0, z: 38.4 }, type: ROOM_TYPE.MEETING },
    "7": { position: { x: 6.7, y: 7.0, z: 47.7 }, type: ROOM_TYPE.MEETING },
    "8": { position: { x: -8.2, y: 8.0, z: 55.1 }, type: ROOM_TYPE.MEETING },
    "9": { position: { x: -22.0, y: 9.0, z: 60.9 }, type: ROOM_TYPE.MEETING },
    "10": { position: { x: 6.0, y: 10.0, z: 61.4 }, type: ROOM_TYPE.MEETING },
    "11": { position: { x: -42.3, y: 11.0, z: 39.3 }, type: ROOM_TYPE.WEBINAR },
    "12": {
      position: { x: 18.97, y: 12.0, z: -17.29 },
      type: ROOM_TYPE.NORMAL,
    },
  },
  FESTIVAL: {
    "0": { position: { x: 21.01, y: 3.56, z: -9.8 }, type: ROOM_TYPE.MEETING },
    "1": { position: { x: 22.54, y: 3.56, z: 1.56 }, type: ROOM_TYPE.MEETING },
    "2": { position: { x: 22.62, y: 3.56, z: 11.85 }, type: ROOM_TYPE.MEETING },
    "3": { position: { x: -11.56, y: 2.56, z: 1.5 }, type: ROOM_TYPE.WEBINAR },
    "4": { position: { x: -43.8, y: 3.56, z: -9.9 }, type: ROOM_TYPE.MEETING },
    "5": { position: { x: -43.3, y: 3.56, z: 1.2 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: -43.5, y: 3.56, z: 11.4 }, type: ROOM_TYPE.MEETING },
    "7": { position: { x: -51.4, y: 3.56, z: -9.5 }, type: ROOM_TYPE.MEETING },
    "8": { position: { x: -51.4, y: 3.56, z: 1.1 }, type: ROOM_TYPE.MEETING },
    "9": { position: { x: -51.4, y: 3.56, z: 11.6 }, type: ROOM_TYPE.MEETING },
    "10": { position: { x: -63.5, y: 3.56, z: -9.6 }, type: ROOM_TYPE.MEETING },
    "11": { position: { x: -63.4, y: 3.56, z: 1.0 }, type: ROOM_TYPE.MEETING },
    "12": { position: { x: -63.4, y: 3.56, z: 11.5 }, type: ROOM_TYPE.MEETING },
    "13": {
      position: { x: -71.5, y: 3.56, z: -10.1 },
      type: ROOM_TYPE.MEETING,
    },
    "14": { position: { x: -71.5, y: 3.56, z: 1.1 }, type: ROOM_TYPE.MEETING },
    "15": { position: { x: -71.3, y: 3.56, z: 11.2 }, type: ROOM_TYPE.MEETING },
    "16": { position: { x: -81.7, y: 3.56, z: 15.7 }, type: ROOM_TYPE.NORMAL },
    "17": { position: { x: -81.8, y: 3.56, z: 0.9 }, type: ROOM_TYPE.NORMAL },
    "18": { position: { x: -82.1, y: 3.56, z: -13.9 }, type: ROOM_TYPE.NORMAL },
  },
  LARGE: {
    "0": {
      position: { x: 16.01, y: 3.56, z: -1.49 },
      type: ROOM_TYPE.WEBINAR,
    },
    "1": { position: { x: 8.61, y: 3.56, z: 12.68 }, type: ROOM_TYPE.NORMAL },
    "2": { position: { x: 8.61, y: 3.56, z: 7.16 }, type: ROOM_TYPE.NORMAL },
    "3": { position: { x: 8.61, y: 3.56, z: 2.17 }, type: ROOM_TYPE.NORMAL },
    "4": { position: { x: 1.19, y: 3.56, z: 8.53 }, type: ROOM_TYPE.NORMAL },
    "5": { position: { x: -6.58, y: 3.56, z: 8.53 }, type: ROOM_TYPE.NORMAL },
    "6": { position: { x: -14.0, y: 3.56, z: 8.53 }, type: ROOM_TYPE.NORMAL },
    "7": {
      position: { x: -23.87, y: 3.56, z: 8.53 },
      type: ROOM_TYPE.NORMAL,
    },
    "8": {
      position: { x: -36.84, y: 3.56, z: 8.53 },
      type: ROOM_TYPE.NORMAL,
    },
    "9": {
      position: { x: -46.52, y: 3.56, z: 8.53 },
      type: ROOM_TYPE.NORMAL,
    },
    "10": {
      position: { x: -60.9, y: 3.56, z: 12.59 },
      type: ROOM_TYPE.NORMAL,
    },
    "11": {
      position: { x: -60.9, y: 3.56, z: 7.48 },
      type: ROOM_TYPE.NORMAL,
    },
    "12": {
      position: { x: -60.9, y: 3.56, z: 2.24 },
      type: ROOM_TYPE.NORMAL,
    },
    "13": {
      position: { x: -57.95, y: 3.56, z: -8.87 },
      type: ROOM_TYPE.MEETING,
    },
    "14": {
      position: { x: -52.78, y: 3.56, z: -8.87 },
      type: ROOM_TYPE.MEETING,
    },
    "15": {
      position: { x: -47.81, y: 3.56, z: -8.87 },
      type: ROOM_TYPE.MEETING,
    },
    "16": {
      position: { x: -42.64, y: 3.56, z: -8.87 },
      type: ROOM_TYPE.MEETING,
    },
    "17": {
      position: { x: -37.63, y: 3.56, z: -8.87 },
      type: ROOM_TYPE.MEETING,
    },
    "18": {
      position: { x: -32.58, y: 3.56, z: -8.87 },
      type: ROOM_TYPE.MEETING,
    },
    "19": {
      position: { x: -25.03, y: 3.56, z: -8.87 },
      type: ROOM_TYPE.SPEED_NETWORKING,
    },
    "20": {
      position: { x: -17.3, y: 3.56, z: -8.87 },
      type: ROOM_TYPE.MEETING,
    },
    "21": {
      position: { x: -12.41, y: 3.56, z: -8.87 },
      type: ROOM_TYPE.MEETING,
    },
    "22": {
      position: { x: -7.2, y: 3.56, z: -8.87 },
      type: ROOM_TYPE.MEETING,
    },
    "23": {
      position: { x: -2.6, y: 3.56, z: -8.87 },
      type: ROOM_TYPE.MEETING,
    },
    "24": { position: { x: 2.4, y: 3.56, z: -8.9 }, type: ROOM_TYPE.MEETING },
    "25": {
      position: { x: 8.87, y: 3.56, z: -13.68 },
      type: ROOM_TYPE.NORMAL,
    },
    "26": {
      position: { x: -6.86, y: 3.56, z: 13.43 },
      type: ROOM_TYPE.MEETING,
    },
  },
  LEARNING: {
    "0": { position: { x: 15.88, y: 3.56, z: -1.48 }, type: ROOM_TYPE.WEBINAR },
    "1": { position: { x: 8.25, y: 3.56, z: 2.65 }, type: ROOM_TYPE.NORMAL },
    "2": { position: { x: 0.81, y: 3.56, z: 6.32 }, type: ROOM_TYPE.WEBINAR },
    "3": { position: { x: -6.3, y: 3.56, z: 6.32 }, type: ROOM_TYPE.WEBINAR },
    "4": { position: { x: -5.17, y: 3.56, z: -8.05 }, type: ROOM_TYPE.NORMAL },
    "5": { position: { x: 0.89, y: 3.56, z: -8.05 }, type: ROOM_TYPE.MEETING },
    "6": { position: { x: 0.89, y: 3.56, z: -12.51 }, type: ROOM_TYPE.MEETING },
    "7": { position: { x: 8.65, y: 3.56, z: -14.09 }, type: ROOM_TYPE.NORMAL },
    "8": { position: { x: 6.57, y: 3.56, z: -15.01 }, type: ROOM_TYPE.MEETING },
  },
  MEDIUM: {
    "0": { position: { x: 17.28, y: 3.56, z: -4.3 }, type: ROOM_TYPE.NORMAL },
    "1": { position: { x: 15.82, y: 3.56, z: 2.32 }, type: ROOM_TYPE.NORMAL },
    "2": { position: { x: 8.78, y: 3.56, z: 2.32 }, type: ROOM_TYPE.NORMAL },
    "3": { position: { x: 1.37, y: 3.56, z: 7.66 }, type: ROOM_TYPE.NORMAL },
    "4": { position: { x: -6.35, y: 3.56, z: 7.66 }, type: ROOM_TYPE.NORMAL },
    "5": { position: { x: -13.88, y: 3.56, z: 3.25 }, type: ROOM_TYPE.NORMAL },
    "6": {
      position: { x: -28.75, y: 3.56, z: -1.94 },
      type: ROOM_TYPE.MEETING,
    },
    "7": {
      position: { x: -25.57, y: 3.56, z: -10.37 },
      type: ROOM_TYPE.NORMAL,
    },
    "8": {
      position: { x: -7.73, y: 3.56, z: -10.37 },
      type: ROOM_TYPE.SPEED_NETWORKING,
    },
    "9": { position: { x: 1.08, y: 3.56, z: -7.91 }, type: ROOM_TYPE.MEETING },
    "10": {
      position: { x: 1.08, y: 3.56, z: -13.13 },
      type: ROOM_TYPE.MEETING,
    },
    "11": { position: { x: -6.37, y: 3.56, z: 1.0 }, type: ROOM_TYPE.NORMAL },
    "12": { position: { x: 1.01, y: 3.56, z: 1.0 }, type: ROOM_TYPE.NORMAL },
    "13": {
      position: { x: 8.71, y: 3.56, z: -13.64 },
      type: ROOM_TYPE.MEETING,
    },
    "14": { position: { x: -7.23, y: 3.56, z: 3.51 }, type: ROOM_TYPE.MEETING },
  },
  MINISO: {
    "0": { position: { x: 19.54, y: 3.56, z: -8.0 }, type: ROOM_TYPE.NORMAL },
    "1": { position: { x: 0.0, y: 3.56, z: -14.82 }, type: ROOM_TYPE.NORMAL },
    "2": { position: { x: -9.89, y: 3.56, z: -14.82 }, type: ROOM_TYPE.NORMAL },
    "3": { position: { x: 4.64, y: 3.56, z: -14.82 }, type: ROOM_TYPE.NORMAL },
    "4": { position: { x: 8.76, y: 3.56, z: -14.82 }, type: ROOM_TYPE.NORMAL },
    "5": { position: { x: 4.48, y: 3.56, z: -18.04 }, type: ROOM_TYPE.NORMAL },
    "6": { position: { x: -4.92, y: 3.56, z: -5.44 }, type: ROOM_TYPE.NORMAL },
    "7": { position: { x: -11.6, y: 3.56, z: -5.31 }, type: ROOM_TYPE.NORMAL },
    "8": { position: { x: 8.16, y: 3.56, z: -4.03 }, type: ROOM_TYPE.NORMAL },
    "9": { position: { x: -13.08, y: 3.56, z: -6.2 }, type: ROOM_TYPE.NORMAL },
    "10": { position: { x: 8.04, y: 3.56, z: -7.71 }, type: ROOM_TYPE.NORMAL },
    "11": { position: { x: 4.85, y: 3.56, z: 3.54 }, type: ROOM_TYPE.NORMAL },
    "12": { position: { x: -9.63, y: 3.56, z: 3.54 }, type: ROOM_TYPE.NORMAL },
    "13": { position: { x: 8.66, y: 3.56, z: 3.53 }, type: ROOM_TYPE.NORMAL },
    "14": { position: { x: -13.08, y: 3.56, z: 3.54 }, type: ROOM_TYPE.NORMAL },
    "15": {
      position: { x: -2.33, y: 3.56, z: -9.76 },
      type: ROOM_TYPE.WEBINAR,
    },
    "16": {
      position: { x: 1.67, y: 3.56, z: -22.71 },
      type: ROOM_TYPE.MEETING,
    },
    "17": {
      position: { x: -8.34, y: 3.56, z: -22.71 },
      type: ROOM_TYPE.MEETING,
    },
  },
  SMALL: {
    "0": { position: { x: 16.13, y: 2.0, z: -3.7 }, type: ROOM_TYPE.WEBINAR },
    "1": { position: { x: 15.88, y: 2.0, z: 2.65 }, type: ROOM_TYPE.NORMAL },
    "2": { position: { x: 8.25, y: 2.0, z: 2.65 }, type: ROOM_TYPE.NORMAL },
    "3": { position: { x: -6.76, y: 2.0, z: 3.52 }, type: ROOM_TYPE.NORMAL },
    "4": { position: { x: -5.17, y: 2.0, z: -8.05 }, type: ROOM_TYPE.NORMAL },
    "5": { position: { x: 1.83, y: 2.0, z: -7.3 }, type: ROOM_TYPE.MEETING },
    "6": {
      position: { x: 2.07, y: 2.0, z: -12.51 },
      type: ROOM_TYPE.MEETING,
    },
    "7": { position: { x: 8.77, y: 2.0, z: -13.83 }, type: ROOM_TYPE.NORMAL },
    "8": {
      position: { x: 7.6, y: 1.93, z: -16.03 },
      type: ROOM_TYPE.MEETING,
    },
  },
  TEMPLE: {
    "0": { position: { x: -7.82, y: 3.56, z: -17.69 }, type: ROOM_TYPE.NORMAL },
    "1": { position: { x: 3.26, y: 3.56, z: -17.66 }, type: ROOM_TYPE.NORMAL },
    "2": { position: { x: -2.45, y: 3.56, z: -3.37 }, type: ROOM_TYPE.WEBINAR },
    "3": {
      position: { x: -3.56, y: 3.56, z: -22.22 },
      type: ROOM_TYPE.MEETING,
    },
  },
};
